import { ENROLLMENTS_IS_FETCHING, ENROLLMENTS_GET_SUCCESS, ENROLLMENTS_GET_ERROR } from './constants';

// Initial State
export const initialState = {
  isFetching: false,
  info: {},
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ENROLLMENTS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case ENROLLMENTS_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        info: action.payload || {}
      };

    case ENROLLMENTS_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
